import React from 'react'

const BAR_COUNT = 6

const BarChartSkeleton = ({ height = 250 }) => {
    // Simulate bar heights for a more realistic skeleton look
    const barHeights = [80, 160, 60, 100, 90, 130]

    return (
        <div style={{ width: '100%', paddingLeft: 90, position: 'relative' }}>
            <div className="absolute left-0 bottom-[100px] rotate-180 items-center text-[#d1d0e1] select-none" style={{ writingMode: 'vertical-rl' }}>
                <div className="flex flex-col items-center">
                    <div className="h-[180px] w-4 bg-lightBG rounded opacity-50"></div>
                    <div className="h-[120px] w-4 bg-lightBG rounded opacity-50 mr-2"></div>
                </div>
            </div>
            <div className="relative w-full bg-lightBG overflow-hidden animate-pulse" style={{ height }}>
                {/* Vertical grid lines */}
                <div className="absolute top-0 left-0 w-full h-full flex z-0 pointer-events-none">
                    {[...Array(BAR_COUNT)].map((_, i) => (
                        <div
                            key={i}
                            className="h-full"
                            style={{
                                width: `${100 / BAR_COUNT}%`,
                                borderLeft: i === 0 ? 'none' : '1px solid #ECEBF8',
                            }}
                        ></div>
                    ))}
                </div>
                {/* Bars */}
                <div className="relative z-10 flex flex-row items-end justify-between w-full h-full">
                    {barHeights.map((barHeight, i) => (
                        <div
                            key={i}
                            className="bg-[#d1d0e1] rounded-t-[6px] rounded-b mx-auto"
                            style={{
                                width: '100%',
                                height: barHeight,
                                opacity: 0.7 - i * 0.04,
                                marginLeft: 10,
                                marginRight: 10,
                            }}
                        ></div>
                    ))}
                </div>
            </div>
            <div className="flex flex-row justify-between items-center px-16 mt-2 w-full z-20">
                {barHeights.map((_, i) => (
                    <div className="flex flex-col items-center gap-2">
                        <div key={i} className="h-2 w-10 bg-lightPurpleGray rounded-full opacity-60"></div>
                        <div className="h-8 w-8 bg-lightPurpleGray rounded-full opacity-60"></div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default BarChartSkeleton

export const BarChartHeaderSkeleton = () => (
    <div className="flex flex-row items-center justify-between mt-[30px] mb-[35px] w-full">
        <div className="h-7 w-[180px] bg-[#ecebf8] rounded opacity-50"></div>
        <div className="h-5 w-[220px] bg-[#ecebf8] rounded opacity-30"></div>
    </div>
)
